module.exports = __webpack_public_path__ + "img/networking-zies.2be298b6.png";